import { Stack } from "@mui/material";
import { AdmissionForm } from "./AdmissionForm";
import { StudentFormDataProvider } from "./StudentDataFormProvider";
import NavBar from "../MarketingPage/NavBar/NavBar";

export const AdmissionFormPage = () => {
  return (
    <StudentFormDataProvider>
      <NavBar />
      <Stack
        sx={{
          background: "#58D6CE",
          padding: { xs: "0.5rem", md: "1rem 5rem" },
          justifyContent: "flex-start",
          alignItems: "center",
          display: "flex",
          width: "100%",
          height: "150%",
          minHeight: "100vh",
          marginTop: { xs: "0" },
        }}
      >
        <AdmissionForm />
      </Stack>
    </StudentFormDataProvider>
  );
};
